export const SUM_OPTION_LOC_KEY = "GUI-708294"; // Celkem
export const AVG_OPTION_LOC_KEY = "GUI-708295"; // Průměr
export const MIN_OPTION_LOC_KEY = "GUI-708296"; // Min
export const MAX_OPTION_LOC_KEY = "GUI-708297"; // Max
export const SELECT_OPTION_LOC_KEY = "GUI-311684"; // Vybrat
